export enum STORY_TYPES {
  FEATURE = 'Feature',
  DESIGN = 'Design',
  BUG = 'Bug',
  CHORE = 'Chore',
  RELEASE = 'Release',
}
